import { useCountryCodeForDropsRole } from "shared/hooks/useCountryCodeForDropsRole";
import { countryCodeToLanguage, Language } from "shared/types/language";

/**
 * Includes English as these are always prevalent for custom texts
 */
export function useLanguagesForDropsRole(): Language[] {
  const countryCodeForDropsRole = useCountryCodeForDropsRole();
  const languageForDropsRole = countryCodeToLanguage[countryCodeForDropsRole];
  const languages: Language[] = [languageForDropsRole, "ENG"] as const;
  return languages;
}
